import { render, staticRenderFns } from "./DepartementsList.vue?vue&type=template&id=30cbfd82&scoped=true&"
import script from "./DepartementsList.vue?vue&type=script&lang=js&"
export * from "./DepartementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cbfd82",
  null
  
)

export default component.exports